import React from 'react';
import styled from 'styled-components';
import chroma from 'chroma-js';

const cardColor = chroma('#a8d2de');

const Container = styled.div`
  background-color: ${cardColor.hex()};
  padding: 1rem;
  border-bottom: 2px solid ${cardColor.darken().hex()};
  border-radius: 1rem;
  font-family: sans-serif;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 1.25rem;
  text-align: center;
`;

const NumberHighlight = styled.div`
  border: 2px solid red;
  padding: 0.1rem 0.5rem;
  border-radius: 0.5rem;
  float: right;
`;

const BottomSection = styled.div`
  margin-top: 1rem;
`;

const CardNumberDisplay = styled.div`
  font-size: 1.5rem;
  white-space: nowrap;
  clear: both;
`;

export default () => (
  <Container>
    <Title>AMERICAN EXPRESS</Title>
    <BottomSection>
      <NumberHighlight>1234</NumberHighlight>
      <CardNumberDisplay>3333 123456 90000</CardNumberDisplay>
    </BottomSection>
  </Container>
);
